export default __webpack_public_path__ + "static/firefighters-f630e2fe30185a0c7183c58f765722e3.png";